class Role {
    constructor(role){
        this.name = role.name;
        this.slug = role.slug;
        this.company_level = role.company_level;
        this.library_level = role.library_level;
    }
}

export default Role;